import React, { useState, useEffect } from "react";

import TextArea from "../Common/TextArea";

const CHAR_LIMIT = 280;

let myCount = 0;

export default function MissionDetails(props) {
    const mission = props.mission;

    const [wordCount, setWordCount] = useState(0);

    const onDescriptionChange = (value, event) => {
        const pluginCount = event.plugins.wordcount;
        const charcount = pluginCount.body.getCharacterCount();

        // charcount > wordCount needed for current description which is longer than 280
        if (charcount > CHAR_LIMIT && charcount > wordCount) {
            return;
        }

        // setWordCount(charcount); // For some reason setting the state here make it very slow
        myCount = charcount;

        props.handleChange({
            target: {
                type: "textarea",
                name: "description",
                value: value,
            },
        });
    };

    const onTextareaInit = (event) => {
        const editor = event.target;
        const pluginCount = editor.plugins.wordcount;

        const charcount = pluginCount.body.getCharacterCount();

        setWordCount(charcount);
    };

    useEffect(() => {
        setWordCount(myCount);
    }, [myCount])

    return (
        <React.Fragment>
            <h4 className="primary-color">MISSION DETAILS</h4>

            <div id="mission-steps" className="edit-mission-box">
                <div className="input-container">
                    <label className="form-label mt-0 " htmlFor="name">
                        Mission Title:
                    </label>
                    <input
                        type="text"
                        className="form-control"
                        value={mission.name}
                        id="name"
                        name="name"
                        onChange={props.handleChange}
                        placeholder='e.g. "Running the length of the Great Wall of China"'
                        tabIndex="1"
                        maxLength="100"
                    />
                </div>

                <div className="input-container">
                    <label className="form-label mt-4" htmlFor="description">
                        Mission Description:
                    </label>
                    {props.showWysiwyg ? (
                        <>
                            <TextArea
                                name="description"
                                value={mission.description}
                                init={{
                                    height: 180,
                                    paste_as_text: true,
                                    paste_data_images: false,
                                    paste_block_drop: true,
                                    toolbar:
                                    "undo redo | bold italic | \
                        			| link",
                                    remove_linebreaks: true,
                                    forced_root_block: false,
                                    placeholder: "What is your mission about?"
                                }}
                                count={wordCount}
                                limit={CHAR_LIMIT}
                                onChange={onDescriptionChange}
                                onInit={onTextareaInit}
                            />
                            {wordCount > CHAR_LIMIT && (
                                <p className="danger text-end">
                                    The description is too long
                                </p>
                            )}
                        </>
                    ) : (
                        <textarea
                            className="form-control"
                            id="description"
                            name="description"
                            value={mission.description}
                            tabIndex="2"
                            placeholder="What is your mission about?"
                            onChange={props.handleChange}
                            maxLength="280"
                        />
                    )}
                </div>

                <div className="input-container">
                    <label className="form-label mt-4" htmlFor="travel_from">
                        Mission Origin:
                    </label>
                    <input
                        type="text"
                        className="col-12 form-control"
                        value={mission.travel_from}
                        id="travel_from"
                        name="travel_from"
                        placeholder='e.g. "Beijing, China"'
                        onChange={props.handleChange}
                        tabIndex="3"
                    />
                </div>

                <div className="input-container">
                    <label className="form-label mt-4" htmlFor="travel_to">
                        Destination:
                    </label>
                    <input
                        type="text"
                        className="col-12 form-control"
                        value={mission.travel_to}
                        onChange={props.handleChange}
                        id="travel_to"
                        name="travel_to"
                        placeholder='e.g. "Bangkok, Thailand"'
                        tabIndex="4"
                    />
                </div>

                <figcaption className="mt-4 mb-0 blockquote-footer secondary-color text-center">
                    Do not enter exact address details for your own privacy
                    reasons.
                </figcaption>
            </div>
        </React.Fragment>
    );
}
